import { apiClient } from './client'
import type { CursorPage } from './accounts'
import type { CaseTeamMemberView, TeamRole } from '../types/caseTeam'

/**
 * Typed fetch wrappers for `module.case_`'s `CaseTeamMember` roster
 * (IB-51, `docs/design/IB-51-case-team-design.md` §3.3/§6) — same
 * thin-wrapper convention as `api/cases.ts`/`api/dossier.ts`.
 */

export async function listCaseTeamMembers(
  caseId: string,
  cursor?: string | null,
  signal?: AbortSignal,
): Promise<CursorPage<CaseTeamMemberView>> {
  const q = new URLSearchParams()
  if (cursor) q.set('cursor', cursor)
  q.set('limit', '200')
  const { data } = await apiClient.get<CursorPage<CaseTeamMemberView>>(
    `/cases/${caseId}/team-members?${q.toString()}`,
    { signal },
  )
  return data
}

export async function assignTeamMember(
  caseId: string,
  teamRole: TeamRole,
  userId: string,
): Promise<CaseTeamMemberView> {
  const { data } = await apiClient.post<CaseTeamMemberView>(`/cases/${caseId}/team-members`, {
    teamRole,
    userId,
  })
  return data
}

export async function reassignTeamMember(
  caseId: string,
  memberId: string,
  newUserId: string,
): Promise<CaseTeamMemberView> {
  const { data } = await apiClient.post<CaseTeamMemberView>(
    `/cases/${caseId}/team-members/${memberId}/reassign`,
    { newUserId },
  )
  return data
}

/** AC7 — no replacement required; `active` is always `false` (reactivation is out of scope for v1). */
export async function deactivateTeamMember(caseId: string, memberId: string): Promise<CaseTeamMemberView> {
  const { data } = await apiClient.patch<CaseTeamMemberView>(`/cases/${caseId}/team-members/${memberId}`, {
    active: false,
  })
  return data
}
